// Quack, this is a duck :) https://github.com/erikras/ducks-modular-redux
/** ************************
 * Error bundle
 ************************ */
// Actions
export const SET_ERROR = 'Setting error';
export const CLEAR_ERROR = 'Cleared app level error';

// Reducer
export default function reducer(state = null, action) {
    switch (action.type) {
        case SET_ERROR:
            return Object.assign({}, state, {
                message: action.error.message,
                stack: action.error.stack,
            });
        case CLEAR_ERROR:
            return null;
        default:
            return state;
    }
}

// Action Creators/Thunks
export const clearError = () => dispatch => dispatch({ type: CLEAR_ERROR });
export const setError = error => dispatch => dispatch({ type: SET_ERROR, error });
